import consumer from "./consumer"

function  tellDocument (data) {
  const event = new CustomEvent('PresenceChannelEvent', { detail: data });
  document.dispatchEvent(event)
}

function findEventSlug () {
  const body = document.getElementsByTagName('body')[0]

  if (body === undefined)
    return null;

  return body.getAttribute('data-event-slug')
}


function featureEnabled() {
  return true
}

if (featureEnabled()) {

  // TODO: use window.KastioActionCable.subscribe from Angular code
  let sub = consumer.subscriptions.create({ channel: 'PresenceChannel', event_id: findEventSlug() }, {
    connected() {
      // Called when the subscription is ready for use on the server
      console.log("Connected to the PresenceChannel!");
    },

    disconnected() {
      // Called when the subscription has been terminated by the server
    },

    received(data) {
      // Called when there's incoming data on the websocket for this channel
      tellDocument(data)
    }
  });

  window.presenceChannelSub = sub

}